<template>
    <div class="flex flex-col">
        <div class="flex justify-between">
            <div class="text-sm text-textGray">
                Sections
            </div>
            <div
                class="flex items-center px-2 text-green-100 bg-green-500 rounded-full cursor-pointer"
                @click="showSectionModal()"
            >
                +
            </div>
        </div>
        <div class="flex mb-4 space-x-4">
            <div
                v-for="(singleSection, index) in content.sections"
                :key="index"
                class="cursor-pointer hover:underline hover:font-medium"
                :class="{
                    'underline font-medium': index === section,
                }"
                @click="selectSection(index)"
            >
                {{ singleSection.title }}
            </div>
        </div>
        <div class="flex mb-4 space-x-4" v-if="section !== null">
            <div
                class="px-2 py-1 text-xs text-red-100 uppercase bg-red-500 cursor-pointer"
                @click="deletePart('section')"
            >
                Delete
            </div>
            <div
                class="px-2 py-1 text-xs text-yellow-100 uppercase bg-yellow-500 cursor-pointer"
                @click="editPart('section')"
            >
                Edit
            </div>
        </div>
        <div class="flex justify-between" v-if="section !== null">
            <div class="text-sm text-textGray">Links</div>
            <div
                class="flex items-center px-2 text-green-100 bg-green-500 rounded-full cursor-pointer"
                @click="showLinkModal()"
            >
                +
            </div>
        </div>
        <div class="flex mb-4 space-x-4" v-if="section !== null">
            <div
                v-for="(singleLink, index) in content.sections[
                    section
                ].links"
                :key="index"
                class="cursor-pointer hover:underline hover:font-medium"
                :class="{
                    'underline font-medium': index === link,
                }"
                @click="selectLink(index)"
            >
                {{ singleLink.title }}
            </div>
        </div>
        <div class="flex mb-4 space-x-4" v-if="link !== null">
            <div
                class="px-2 py-1 text-xs text-red-100 uppercase bg-red-500 cursor-pointer"
                @click="deletePart('link')"
            >
                Delete
            </div>
            <div
                class="px-2 py-1 text-xs text-yellow-100 uppercase bg-yellow-500 cursor-pointer"
                @click="editPart('link')"
            >
                Edit
            </div>
        </div>
        <div v-if="link !== null" class="relative">
            <MarkdownEditor
                v-model="
                    content.sections[section].links[link].content
                "
                class="p-8 bg-white rounded-panel"
                theme="dark"
            ></MarkdownEditor>
            <div
                ref="saveButton"
                class="absolute bottom-0 right-0 px-6 py-2 text-sm font-medium text-blue-600 bg-blue-200 cursor-pointer rounded-panel hover:bg-blue-500 hover:text-blue-200"
                @click="saveContent()"
            >
                SAVE
            </div>
        </div>
        <!-- Modals -->
        <modal
            ref="sectionModal"
            placeholder="Section name"
            @save="createSection"
            @edit="editSection"
        ></modal>
        <modal
            ref="linkModal"
            placeholder="Link name"
            @save="createLink"
            @edit="editLink"
        ></modal>
    </div>
</template>
<script>
export default {
    props: ['selectedPage'],
    data() {
        return {
            link: null,
            section: null,
            content: this.selectedPage.content,
        };
    },
    methods: {
        showSectionModal() {
            this.$refs.sectionModal.show();
        },
        showLinkModal() {
            this.$refs.linkModal.show();
        },
        createSection(name) {
            if (typeof this.content.sections !== 'undefined') {
                this.content.sections.push({
                    title: name,
                    links: [],
                });
            } else {
                this.content.sections = [
                    {
                        title: name,
                        links: [],
                    },
                ];
            }
        },
        editSection(value) {
            this.content.sections[this.section].title = value;
            this.saveContent(false);
        },
        createLink(name) {
            this.content.sections[this.section].links.push({
                title: name,
                content: '',
            });
        },
        editLink(value) {
            this.content.sections[this.section].links[
                this.link
            ].title = value;
            this.saveContent(false);
        },
        selectSection(index) {
            this.section = index;
            this.link = null;
        },
        selectLink(index) {
            this.link = index;
        },
        saveContent(animate = true) {
            if (animate) {
                this.$refs.saveButton.classList.add('animate-pulse');
            }
            axios
                .post('/api/pages', {
                    id: this.selectedPage.id,
                    content: this.content,
                })
                .then(() => {
                    if (animate) {
                        this.$refs.saveButton.classList.remove(
                            'animate-pulse',
                        );
                        this.$refs.saveButton.innerHTML = 'SAVED';
                        setTimeout(() => {
                            this.$refs.saveButton.innerHTML = 'SAVE';
                        }, 2000);
                    }
                });
        },
        deletePart(part) {
            if (part === 'section') {
                this.content.sections.splice(this.section, 1);
                this.section = null;
            } else if (part === 'link') {
                this.content.sections[this.section].links.splice(
                    this.link,
                    1,
                );
                this.link = null;
                if (
                    !this.content.sections[this.section].links.length
                ) {
                    this.section = null;
                }
            }
            this.saveContent(false);
        },
        editPart(part) {
            if (part === 'section') {
                this.$refs.sectionModal.show(
                    this.content.sections[this.section].title,
                );
            } else if (part === 'link') {
                this.$refs.linkModal.show(
                    this.content.sections[this.section].links[
                        this.link
                    ].title,
                );
            }
        },
    },
};
</script>
